import Carousel from '../../components/carousel/Carousel'

import {VisibilityOutlined, VisibilityOffOutlined} from '@material-ui/icons'
import { useRef, useState } from 'react'

import Axios from 'axios'
import { useHistory } from 'react-router'

import './register.css'
import { Link } from 'react-router-dom'

const Register = () => {
    //ADD THE FORM VALIDATION

    const [isRevealed, setIsRevealed] = useState(false)
    const [error, setError] = useState("")

    const showPassword = () => {
        setIsRevealed(() => !isRevealed)
    }
    const API = process.env.REACT_APP_API_URL
    const PF = process.env.REACT_APP_PUBLIC_FOLDER

    const firstname = useRef()
    const lastname = useRef()
    const email = useRef()
    const password = useRef()
    const history = useHistory()

    const handleOnSubmit = async (e) => {
        e.preventDefault()
        //implement form validation here 
        const user = {
            firstname: firstname.current.value,
            lastname: lastname.current.value,
            email: email.current.value,
            password: password.current.value
        }
        try {
            const res = await Axios.post(API + "auth/register", user);
            history.push('/login')
        } catch (error) {
            if(error.response && (error.response.status >= 400 && error.response.status <= 500)){
                setError(error.response.data.msg)
            }
        }
        
    }
    return (
        <div className="login">
            <div className="loginWrapper">
                <div className="loginLeft">
                    <form className="loginBox" onSubmit={handleOnSubmit}>
                        <div className='loginBloomLogoWrapper'>
                            <img src={PF + 'person/bloom logo.png'} className='loginBloomLogo'/>
                            <h5 className='welcomeToBloom'>Welcome to Bloom</h5>
                            <p className='welcomeToBloomParagraph'>
                                The website where you can share your love of nature, your photos 
                                and your experiences with other photographers and with the world. 
                                Buckle up and get ready
                            </p>
                        </div>
                        {
                            error &&
                            <div className="alert alert-danger" role="alert">
                                {error}
                            </div>
                        }
                        <div className='fullnameInput'>
                            <div className="inputField">
                                <input type="text" placeholder='First Name' ref={firstname} className="loginInput"/>
                            </div>
                            <div className="inputField">
                                <input type="text" placeholder='Last Name' ref={lastname} className="loginInput"/>
                            </div>
                        </div>
                        <div className="inputField">
                            <input type="text" placeholder='Email' ref={email} className="loginInput"/>
                        </div>
                        <div className="inputField">
                            <input type={isRevealed ? "text" : "password"} placeholder='Password' ref={password} className="loginInput"/>
                            <span className="showPassword" onClick={showPassword}>{isRevealed ?  <VisibilityOffOutlined /> : <VisibilityOutlined />}</span>
                        </div>
                        <div className="inputField">
                            <input type={isRevealed ? "text" : "password"} placeholder='Confirm Password' className="loginInput"/>
                            <span className="showPassword" onClick={showPassword}>{isRevealed ?  <VisibilityOffOutlined /> : <VisibilityOutlined />}</span>
                        </div>
                        <div className="loginLeftBottom">
                            <button className="loginButton" type="submit">Register</button>
                            <Link to={'/login'} style={{textDecoration: 'none'}}>
                                <p className="createAccount">Already have an account?</p>
                            </Link>
                        </div>
                    </form>
                </div>
                <div className="loginRight">
                    <Carousel/>
                </div>
            </div>
        </div>
    )
}

export default Register
